export default "__VITE_ASSET__9bc11369__"